module.exports = __webpack_public_path__ + "static/media/TUTORIAL-PORTRAIT.d491d06c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tutorial/img/TUTORIAL-PORTRAIT.png
// module id = 308
// module chunks = 0